import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "@/context/CartContext";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Science from "@/pages/Science";
import Benefits from "@/pages/Benefits";
import Ingredients from "@/pages/Ingredients";
import HowToUse from "@/pages/HowToUse";
import Product from "@/pages/Product";
import Bundles from "@/pages/Bundles";
import Testimonials from "@/pages/Testimonials";
import Philosophy from "@/pages/Philosophy";
import Journal from "@/pages/Journal";
import Cart from "@/pages/Cart";
import CheckoutSuccess from "@/pages/CheckoutSuccess";

function App() {
  return (
    <div className="App font-body">
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/science" element={<Science />} />
              <Route path="/benefits" element={<Benefits />} />
              <Route path="/ingredients" element={<Ingredients />} />
              <Route path="/how-to-use" element={<HowToUse />} />
              <Route path="/product" element={<Product />} />
              <Route path="/bundles" element={<Bundles />} />
              <Route path="/testimonials" element={<Testimonials />} />
              <Route path="/about" element={<Philosophy />} />
              <Route path="/journal" element={<Journal />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout/success" element={<CheckoutSuccess />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </CartProvider>
    </div>
  );
}

export default App;
